function intersectRect(r1, r2) {
    var r1 = r1.getBoundingClientRect();    //BOUNDING BOX OF THE FIRST OBJECT
    var r2 = r2.getBoundingClientRect();    //BOUNDING BOX OF THE SECOND OBJECT
 
    //CHECK IF THE TWO BOUNDING BOXES OVERLAP
  return !(r2.left > r1.right || 
           r2.right < r1.left || 
           r2.top > r1.bottom ||
           r2.bottom < r1.top);
}
var selectClick = function(){
	var clicked = [],
		chart;
	function clickSelection(dataSet){
		var click = d3.select(clicked[clicked.length - 1]);
		var color = click.attr('fill').toUpperCase().substr(1, (colors.length - 1));
		if(mainGraphFilter != 'deficiencies' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis' && mainGraphFilter != 'compare-star'){
			for(var i = 0; i < dataSet.data.value.names['all'].length; i++){
				if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
					$('tr#'+dataSet.data.value.names['all'][i]['id']+'_'+((graphType == 'Pie' || graphType == 'Doughnut') ? dataSet.data.value.names['all'][i]['paytype'] : dataSet.data.value.type)).addClass('click').addClass('_'+color);
				}else{
					$('tr#'+dataSet.data.value.names['all'][i]['id']).addClass('click').addClass('_'+color);
				}
			}
		}else if(mainGraphFilter == 'deficiencies'){
			for(var i = 0; i < dataSet.data.value.names['all'].length; i++){
				$('tr.'+dataSet.data.value.td_uid).addClass('click').addClass('_'+color);
			}
		}else if(mainGraphFilter == 'surveys' || mainGraphFilter == 'qis'){
			for(var i = 0; i < dataSet.data.value.names['all'].length; i++){
				$('tr.'+dataSet.data.value.names['all'][i].answer+'.'+classDateFormat(dataSet.data.value.names['all'][i].date)).addClass('click').addClass('_'+color);
			}
		}else if(mainGraphFilter == 'compare-star'){
			if(graphType != 'Pie' && graphType != 'Doughnut'){
				if(nearbyRange == 'federal' || nearbyRange == 'state'){
					if(dataSet.data.value.other == '') return;
					$('tr#'+dataSet.data.value.other.replace(/\s/g, '-')).addClass('click').addClass('_'+color);
				}else{
					$('tr#'+dataSet.data.value.provider_number).addClass('click').addClass('_'+color);
				}
			}else{
				$('tr.'+dataSet.data.key).addClass('click').addClass('_'+color);
			}
			if(clicked.length == 1 && (nearbyRange != 'federal' && nearbyRange != 'state')){
				for(var mark in markers){
					if(mark == thisFacilityData.federal_provider_number){
						markers[mark].setIcon('/images/map/thisNursing.png');
					}else{
						markers[mark].setIcon('/images/map/otherNursingHover.png');
					}
					markers[mark].selected = false;
				}
			}
			if(nearbyRange != 'federal' && nearbyRange != 'state'){
				if(dataSet.data.value.provider_number == thisFacilityData.federal_provider_number){
					markers[dataSet.data.value.provider_number].setIcon('/images/map/thisNursing.png');
				}else{
					markers[dataSet.data.value.provider_number].setIcon('/images/map/otherNursing.png');
				}
			}
		}
		chart.selectAll(selectForTip).classed('fade', true);
		click.classed('fade', false).classed('clicked', true);
	}
	function unClickSelection(index, dataSet){
		var unClick = d3.select(clicked[index]);
		unClick.classed('clicked', false);
		if(mainGraphFilter != 'deficiencies' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis' && mainGraphFilter != 'compare-star'){
			for(var i = 0; i < dataSet.data.value.names['all'].length; i++){
				if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
					$('tr#'+dataSet.data.value.names['all'][i]['id']+'_'+((graphType == 'Pie' || graphType == 'Doughnut') ? dataSet.data.value.names['all'][i]['paytype'] : dataSet.data.value.type)).removeClass('click');
				}else{
					$('tr#'+dataSet.data.value.names['all'][i]['id']).removeClass('click');
				}
			}
		}else if(mainGraphFilter == 'deficiencies'){
			for(var i = 0; i < dataSet.data.value.names['all'].length; i++){
				$('tr.'+dataSet.data.value.td_uid).removeClass('click');
			}
		}else if(mainGraphFilter == 'surveys' || mainGraphFilter == 'qis'){
			for(var i = 0; i < dataSet.data.value.names['all'].length; i++){
				$('tr.'+dataSet.data.value.names['all'][i].answer+'.'+classDateFormat(dataSet.data.value.names['all'][i].date)).removeClass('click');
			}
		}else if(mainGraphFilter == 'compare-star'){
			if(graphType != 'Pie' && graphType != 'Doughnut'){
				if(nearbyRange == 'federal' || nearbyRange == 'state'){
					if(dataSet.data.value.other == '') return;
					$('tr#'+dataSet.data.value.other.replace(/\s/g, '-')).removeClass('click');
				}else{
					$('tr#'+dataSet.data.value.provider_number).removeClass('click');
				}
			}else{
				$('tr.'+dataSet.data.key).removeClass('click');
			}
			if(nearbyRange != 'federal' && nearbyRange != 'state'){
				if(dataSet.data.value.provider_number == thisFacilityData.federal_provider_number){
					markers[dataSet.data.value.provider_number].setIcon('/images/map/thisNursing.png');
				}else{
					markers[dataSet.data.value.provider_number].setIcon('/images/map/otherNursingHover.png');
				}
			}
			if(clicked.length == 1){
				for(var mark in markers){
					if(mark == thisFacilityData.federal_provider_number){
						markers[mark].setIcon('/images/map/thisNursing.png');
					}else{
						markers[mark].setIcon('/images/map/otherNursingHover.png');
					}
					markers[mark].selected = false;
				}
			}
		}
		clicked.splice(index, 1);
		if(clicked.length === 0){
			chart.selectAll(selectForTip).classed('fade', false);
			for(var mark in markers){
				if(mark == thisFacilityData.federal_provider_number){
					markers[mark].setIcon('/images/map/thisNursing.png');
				}else{
					markers[mark].setIcon('/images/map/otherNursing.png');
				}
				markers[mark].selected = false;
			}
		}else{
			unClick.classed('fade', true);
		}
	}
	var setChart = function(charting){
		chart = charting;
	}
	var toggleClick = function(selection, dataSet){
		if(clicked.indexOf(selection) != -1){
			unClickSelection(clicked.indexOf(selection), dataSet);
		}else{
			clicked.push(selection);
			clickSelection(dataSet);
		}
	};
	var api = {
				setChart: setChart,
				toggleClick: toggleClick,
			};
	return api;
}();
function createMainChartRenderlet(){
    mainChart.renderlet(function(chart){
    	chart.selectAll('.chart-body').attr('clip-path', null);
    	chart.selectAll('title').remove();
    	if((mainGraphFilter == 'physician' || mainGraphFilter == 'paytype' || mainGraphFilter == 'origin' || mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted') && (graphType == 'Line' || graphType == 'Area')){
    		if(mainGraphFilter == 'paytype'){
    			var colors = getPieColors(financialChart).values;
    		}else if(mainGraphFilter == 'physician'){
    			var colors = getPieColors(physicianChart).values;
    		}else if(mainGraphFilter == 'origin'){
    			var colors = getPieColors(originChart).values;
    		}else if(mainGraphFilter == 'rawreadmission'){
    			var colors = getPieColors(rawreadmissionChart).values;
    		}else if(mainGraphFilter == 'riskadjusted'){
    			var colors = getPieColors(riskadjustedChart).values;
    		}
    		chart.selectAll(selectForLegend).each(function(d){
    			var that = d3.select(this);
    			if(d.x in colors){
    				that.attr('fill', colors[d.x]);
    			}
    		});
    	}
    	if(mainGroup.all().length != 0){
    		chart.selectAll(selectForTip).call(mainGraphTip);
    	}
    	mainGraphTip.direction('e');
    	var layerToUse = 'all';
    	chart.selectAll(selectForTip)
    		.on('mouseover', function(d){
    			mainGraphTip.attr('class', 'd3-tip');
    			var color = d3.select(this);
    			color = color.attr('fill').toUpperCase();
    			color = color.substr(1, (color.length - 1));
    			if(mainGraphFilter != 'deficiencies' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis' && mainGraphFilter != 'compare-star'){
	    			for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
	    				if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
	    					$('tr#'+d.data.value.names[layerToUse][i]['id']+'_'+((graphType == 'Pie' || graphType == 'Doughnut') ? d.data.value.names[layerToUse][i]['paytype'] : d.data.value.type)).addClass('hover').addClass('_'+color);
	    				}else{
	    					$('tr#'+d.data.value.names[layerToUse][i]['id']).addClass('hover').addClass('_'+color);
	    				}
	    			}
    			}else if(mainGraphFilter == 'deficiencies'){
    				//for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
    					$('tr').find('td:nth-child(5)').filter(function(){
    						return $(this).text() === d.data.key;
    					}).parent('tr').addClass('hover').addClass('_'+color);

    					 //td:contains("'+d.data.key+'")').parent('tr').addClass('hover').addClass('_'+color);
    				//}
    			}else if(mainGraphFilter == 'surveys' || mainGraphFilter == 'qis'){
    				for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
    					for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
    						$('tr.'+d.data.value.names[layerToUse][i].answer+'.'+classDateFormat(d.data.value.names[layerToUse][i].date)).addClass('hover').addClass('_'+color);
    					}
    				}
    			}else if(mainGraphFilter == 'compare-star'){
    				if(graphType != 'Pie' && graphType != 'Doughnut'){
    					if(nearbyRange == 'federal' || nearbyRange == 'state'){
    						if(d.data.value.other == '') return;
    						$('tr#'+d.data.value.other.replace(/\s/g, '-')).addClass('hover').addClass('_'+color);
    					}else{
    						$('tr#'+d.data.value.provider_number).addClass('hover').addClass('_'+color);
    					}
    				}else{
    					$('tr.'+d.data.key).addClass('hover').addClass('_'+color);
    				}
    				if(d.data.value.provider_number in markers){
    					markers[d.data.value.provider_number].setAnimation(google.maps.Animation.BOUNCE);
    				}
    			}

    			if(graphType == 'Bar'){
    				if(d3.select(this).node().attributes.height.value != 0){
    					var tip = mainGraphTip.show(d);
    					var tipClasses = tip.attr('class');
    					tipClasses = tipClasses+' _'+color;
    					tip.attr('class', tipClasses);
    				}
    			}else{
    				var tip = mainGraphTip.show(d);
    				var tipClasses = tip.attr('class');
    				tipClasses = tipClasses+' _'+color;
    				tip.attr('class', tipClasses);
    			}
    		})
    		.on('mouseleave', function(d){
    			if(mainGraphFilter != 'deficiencies' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis'  && mainGraphFilter != 'compare-star'){
	    			for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
	    				if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
	    					$('tr#'+d.data.value.names[layerToUse][i]['id']+'_'+((graphType == 'Pie' || graphType == 'Doughnut') ? d.data.value.names[layerToUse][i]['paytype'] : d.data.value.type)).removeClass('hover');
	    				}else{
	    					$('tr#'+d.data.value.names[layerToUse][i]['id']).removeClass('hover');
	    				}
	    			}
    			}else if(mainGraphFilter == 'deficiencies'){
    					$('tr').find('td:nth-child(5)').filter(function(){
    						return $(this).text() === d.data.key;
    					}).parent('tr').removeClass('hover');

    				// for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
    				// 	$('tr.'+d.data.value.td_uid).removeClass('hover');
    				// }
    			}else if(mainGraphFilter == 'surveys' || mainGraphFilter == 'qis'){
    				for(var i = 0; i < d.data.value.names[layerToUse].length; i++){
    					$('tr.'+d.data.value.names[layerToUse][i].answer+'.'+classDateFormat(d.data.value.names[layerToUse][i].date)).removeClass('hover');
    				}
    			}else if(mainGraphFilter == 'compare-star'){
    				if(graphType != 'Pie' && graphType != 'Doughnut'){
    					if(nearbyRange == 'federal' || nearbyRange == 'state'){
    						if(d.data.value.other == '') return;
    						$('tr#'+d.data.value.other.replace(/\s/g, '-')).removeClass('hover');
    					}else{
    						$('tr#'+d.data.value.provider_number).removeClass('hover');
    					}
    				}else{
    					$('tr.'+d.data.key).removeClass('hover');
    				}
    				if((nearbyRange != 'federal' && nearbyRange != 'state') && d.data.value.provider_number in markers){
    					markers[d.data.value.provider_number].setAnimation(null);
    				}
    			}
    			mainGraphTip.hide(d);
    		});
    	
    	//legend
    	if((mainGraphFilter != 'physician' && mainGraphFilter != 'origin' && mainGraphFilter != 'diagnosis') || (graphType == 'Pie' || graphType == 'Doughnut')){
    		createMainLegend(chart);
    	}
    	selectClick.setChart(chart);
		chart.selectAll(selectForTip).on("click", function(d){
			selectClick.toggleClick(this, d);
		});

		if(graphType == 'Bar' || graphType == 'Line' || graphType == 'Area'){
			var isOverlap = false;
			chart.selectAll('.axis.x').selectAll('.tick').each(function(d, i){
				if($(this).next('g').length > 0){
					if(intersectRect(this, $(this).next('g').get()[0])){
						isOverlap = true;
					}
				}
			});
			if(isOverlap){
				chart.selectAll('g.x text')
	     			.attr('transform', 'translate(2,2) rotate(25)')
	     			.style('text-anchor', 'start');
	     		var newHeight = chart.g()[0][0].getBBox().height + 25;
     			chart.svg().attr('height', newHeight);
     		}
		}else if(graphType == 'Pie'){
			chart.selectAll('.pie-slice text').each(function(d){
			});
		}

		if((mainGraphFilter == 'deficiencies' || mainGraphFilter == 'compare-star') && graphType == 'Bar'){
			chart.selectAll('.seperator').remove();
			chart.selectAll('g.stack:not(._0)').selectAll('rect').each(function(d){
				var that = d3.select(this);
				if(that.attr('height') != 0){
					var position = this.getBBox();
					var width = that.attr('width');
					var x = that.attr('x');
					var y = position.y + position.height - .5;
					var border = document.createElementNS('http://www.w3.org/2000/svg','rect');
					this.parentNode.insertBefore(border,this);
					border = d3.select(border);
					border.attr('fill', '#fff').attr('height', 1).attr('width', width).attr('x', x).attr('y', y).classed('seperator', true);
					//that.attr('height', that.attr('height') - .5);
				}
			});
		}
		if(mainGraphFilter == 'compare-star' && graphType == 'Bar'){
			if(nearbyRange == 'federal' || nearbyRange == 'state'){
				chart.selectAll('rect.bar').filter(function(d){if(d.data.value.other == thisFacilityData.facility_name)return true;}).attr('fill', '#E2A82D');
			}else{
				chart.selectAll('rect.bar').filter(function(d){if(d.data.value.provider_number == thisFacilityData.federal_provider_number)return true;}).attr('fill', '#E2A82D');
			}
		}
    });
}

function setCorrectChartType(){
	if(graphType == 'Bar'){
		mainChart = dc.barChart('#main-chart');
	}else if(graphType == 'Line' || graphType == 'Area'){
		mainChart = dc.lineChart('#main-chart');
	}else if(graphType == 'Pie' || graphType == 'Doughnut'){
		mainChart = dc.pieChart('#main-chart');
	}
}

function createMainChart(){
	mainChart = null;
	setCorrectChartType();
	mainChart.resetSvg();
	setMainChartFilter();
	getMainGraphTip();

	if(graphType == 'Bar' || graphType == 'Line' || graphType == 'Area'){
		mainChart
			.width(576)
		    .height(250)
		    .margins({top: 30, right: 50, bottom: 30, left: 30})
		    .dimension(mainDimension);
	    if(mainGraphFilter != 'admissions' && mainGraphFilter != 'discharges' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis'){
	    	mainChart.group(mainGroup);
	    }
		mainChart
		    .elasticY(true)
		    .elasticX(false)
		    .x(d3.scale.ordinal())
		    .xUnits(dc.units.ordinal)
		    .renderHorizontalGridLines(true)
		    .xAxisPadding(0)
		    .renderTitle(false)
		    .renderLabel(false)
		    .brushOn(false);
		    mainChart.yAxis().tickFormat(d3.format('d'));

		    if((mainGraphFilter == 'physician' || mainGraphFilter == 'paytype' || mainGraphFilter == 'origin' || mainGraphFilter == 'diagnosis') && graphType == 'Bar'){
		    	mainChart
		    	.gap(10);
		    }

		    if((mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal') && graphType == 'Bar'){
		    	mainChart
			    .yAxisLabel('Days')
			}

		    if(graphType == 'Bar'){
		    	mainChart.centerBar(true);
		    	selectForTip = 'rect.bar';
		    	selectForLegend = 'rect.bar';
		    }else if(graphType == 'Line'){
		    	selectForTip = 'circle.dot';
		    	selectForLegend = 'circle.dot';
		    }else if(graphType == 'Area'){
		    	selectForTip = 'circle.dot';
		    	selectForLegend = 'circle.dot';
		    	mainChart.renderArea(true);
		    }

		    if(typeof mainValueAccessor.keyAccessor == 'function'){
		    	mainChart
		    		.keyAccessor(mainValueAccessor.keyAccessor);
		    }

		    if(typeof mainValueAccessor.valueAccessor == 'function'){
		    	mainChart
		    		.valueAccessor(mainValueAccessor.valueAccessor);
		    }

		    if(typeof mainValueAccessor.stack == 'function'){
		    	mainChart
		    		.stack(mainGroup, mainValueAccessor.stack);
		    }

	}else if(graphType == 'Pie' || graphType == 'Doughnut'){
		mainChart
			.width(576)
		    .height(250)
		    .dimension(mainDimension)
		    .group(mainGroup)
		    .valueAccessor(function(p){
		    	return p.value.total;
		    })
		    .renderTitle(false)
		    .renderLabel(false);
		    if(graphType == 'Doughnut'){
		    	mainChart
		    		.innerRadius(50);
		    }
		    selectForTip = 'g.pie-slice path';
		    selectForLegend = 'g.pie-slice path';
	}

	if((mainGraphFilter == 'discharges' || mainGraphFilter == 'admissions' || mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted' || mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal' || mainGraphFilter == 'census' || mainGraphFilter == 'surveys' || mainGraphFilter == 'qis') && (graphType == 'Bar' || graphType == 'Line' || graphType == 'Area')){
		setMainGraphAsDateRange();
	}

	if(mainGraphFilter == 'census' && (graphType != 'Pie' && graphType != 'Doughnut')){
		var yDomain = d3.scale.linear().domain([0,100]);
		mainChart
			.elasticY(false)
			.y(yDomain);
	}

	if(graphType == 'Line' || graphType == 'Area'){
		mainChart.interpolate('monotone');
	}

	if(mainGraphFilter == 'compare-star' && (graphType != 'Pie' && graphType != 'Doughnut')){
		mainChart.x(d3.scale.ordinal().domain([1,2,3,4,5]));
		mainChart.margins({top: 30, right: 0, bottom: 30, left: 30});
	}
	

    setColorsAndLegend();
    createMainChartRenderlet();
}

function getPieColors(chart){
	var leftOverColors = colors.slice();
	var pieValues = {};
	chart.selectAll('g.pie-slice').each(function(d, i){
		var self = d3.select(this);
		var fill = self.select('path').attr('fill');
		if(d) pieValues[d.data.key] = fill.toUpperCase();
		if(mainGraphFilter == 'compare-star' && (nearbyRange != 'federal' || nearbyRange != 'state')){
			if(d) pieValues[Math.round(d.data.key)] = fill.toUpperCase();
		}
		leftOverColors.splice(leftOverColors.indexOf(fill), 1);
	});
	return {'values': pieValues, 'leftOver': leftOverColors}
}

function setToPieColors(d,i,chart,stacked){
	if(d.data.value.type == ""){
		return;
	}
	if(typeof stacked == undefined){stacked = false;}
	var getColors = getPieColors(chart);
	var pieValues = getColors.values;
	var leftOverColors = getColors.leftOver;
	if(mainGraphFilter == 'compare-star' && (nearbyRange == 'federal' || nearbyRange == 'state')){
		if(!stacked){
			if(parseFloat(d.data.value.raw) in pieValues){
				return colors.indexOf(pieValues[parseFloat(d.data.value.raw)]);
			}else{
				return colors.indexOf(leftOverColors.pop());
			}
		}
	}else{
		if(!stacked){
			if(d.data.key in pieValues){
				return colors.indexOf(pieValues[d.data.key]);
			}else{
				return colors.indexOf(leftOverColors.pop());
			}
		}else{
			if(d.data.value.type in pieValues){
				return colors.indexOf(pieValues[d.data.value.type]);
			}else{
				return colors.indexOf(leftOverColors.pop());
			}
		}
	}
}

function setColorsAndLegend(){
	mainChart
		.colors(colors);
	if(mainGraphFilter == 'discharges'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				return fixName(d.data.key);
			}
		}else{
			chartLegendFunction = function(d){
				return fixName(d.data.value.type);
			}
		}
	}else if(mainGraphFilter == 'admissions'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				return fixName(d.data.key);
			}
		}else{
			chartLegendFunction = function(d){
				return fixName(d.data.value.type);
			}
		}
	}else if(mainGraphFilter == 'paytype'){
		chartLegendFunction = function(d){
			return fixName(d.data.key);
		}
	}else if(mainGraphFilter == 'rawreadmission'){
		chartLegendFunction = function(d){
			return monthFormat(d.data.key);
		}
	}
	else if(mainGraphFilter == 'riskadjusted'){
		chartLegendFunction = function(d){
			return monthFormat(d.data.key);
		}
	}
	else if(mainGraphFilter == 'lengthofstay'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				return monthFormat(d.data.key);
			}
		}else{
			chartLegendFunction = function(d){
				return fixName(d.data.value.type);
			}
		}
	}
	else if(mainGraphFilter == 'lengthofstaytotal'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				return monthFormat(d.data.key);
			}
		}else{
			chartLegendFunction = function(d){
				return fixName(d.data.value.type);
			}
		}
	}
	else if(mainGraphFilter == 'physician'){
		chartLegendFunction = function(d){
			return fixName(d.data.key);
		}
	}else if(mainGraphFilter == 'origin'){
		chartLegendFunction = function(d){
			return fixName(d.data.key);
		}
	}else if(mainGraphFilter == 'census'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				if(isWithinMonth){
					return d.data.key;
				}else{
					return monthFormat(d.data.key);
				}
			}
		}else{
			chartLegendFunction = function(d){
				return fixName(d.data.value.type);
			}
		}
	}else if(mainGraphFilter == 'deficiencies'){
		chartLegendFunction = function(d){
			return d.data.key;
		}
	}else if(mainGraphFilter == 'compare-star'){
		chartLegendFunction = function(d){
			if(d.data.value.total == 0) return;
			return d.data.key+' Star';
		}
	}else if(mainGraphFilter == 'surveys'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				var key = d.data.key;
				if(answerValues[key]){
                	key = answerValues[key];
            	}
				return key;
			}
		}else{
			chartLegendFunction = function(d){
				var key = d.data.value.type;
				if(answerValues[key]){
                	key = answerValues[key];
            	}
				return key;
			}
		}
	}else if(mainGraphFilter == 'qis'){
		if(graphType == 'Pie' || graphType == 'Doughnut'){
			chartLegendFunction = function(d){
				if(d.data.key == "1"){
					return 'YES';
				}else if(d.data.key == "2"){
					return 'NO';
				}
			}
		}else{
			chartLegendFunction = function(d){
				if(d.data.value.type == "1"){
					return 'YES';
				}else if(d.data.value.type == "2"){
					return 'NO';
				}
			}
		}
	}

	if(mainGraphFilter == 'discharges' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(dischargesChart.colorDomain());
	}else if(mainGraphFilter == 'admissions' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(admissionsChart.colorDomain());
	}else if(mainGraphFilter == 'admissions' && (graphType == 'Bar')){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,admissionsChart,true);
			});
	}else if(mainGraphFilter == 'discharges' && (graphType == 'Bar')){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,dischargesChart,true);
			});
	}else if(mainGraphFilter == 'paytype' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(financialChart.colorDomain());
	}else if(mainGraphFilter == 'paytype' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,financialChart);
			});
	}else if(mainGraphFilter == 'rawreadmission' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(rawreadmissionChart.colorDomain())
			.renderLabel(true)
			.label(function(d){
				return (d.data.value.readmitPercent*100).toFixed(2)+'%';
			});
	}else if(mainGraphFilter == 'rawreadmission' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,rawreadmissionChart);
			});
	}else if(mainGraphFilter == 'riskadjusted' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(riskadjustedChart.colorDomain())
			.renderLabel(true)
			.label(function(d){
				return (d.data.value.riskAdjustPercent*100).toFixed(2)+'%';
			});
	}else if(mainGraphFilter == 'riskadjusted' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,riskadjustedChart);
			});
	}else if(mainGraphFilter == 'lengthofstay' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(lengthofstayChart.colorDomain())
			.renderLabel(true)
			.label(function(d){
				return (d.data.value.avgLOS).toFixed(2) + ' day(s)';
			});
	}else if(mainGraphFilter == 'lengthofstay' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,lengthofstayChart, true);
			});
	}else if(mainGraphFilter == 'lengthofstaytotal' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(lengthofstaytotalChart.colorDomain())
			.renderLabel(true)
			.label(function(d){
				return (d.data.value.los).toFixed(2) + ' day(s)';
			});
	}else if(mainGraphFilter == 'lengthofstaytotal' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,lengthofstaytotalChart, true);
			});
	}else if(mainGraphFilter == 'physician' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(physicianChart.colorDomain());
	}else if(mainGraphFilter == 'physician' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,physicianChart);
			});
	}else if(mainGraphFilter == 'origin' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(originChart.colorDomain());
	}else if(mainGraphFilter == 'origin' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,originChart);
			});
	}else if(mainGraphFilter == 'diagnosis' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(diagnosisChart.colorDomain());
	}else if(mainGraphFilter == 'diagnosis' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,diagnosisChart);
			});
	}else if(mainGraphFilter == 'census' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(censusChart.colorDomain())
			.renderLabel(true)
			.label(function(d){
				return d.data.value.adcAverage.toFixed(2)+'%';
			});
	}else if(mainGraphFilter == 'census' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,censusChart, true);
			});
	}else if(mainGraphFilter == 'deficiencies' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(deficiencyChart.colorDomain());
	}else if(mainGraphFilter == 'deficiencies' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,deficiencyChart);
			});
	}else if(mainGraphFilter == 'deficiencies'){
		mainChart
			.colorAccessor(function(d,i){
				return i;
			});
	}else if(mainGraphFilter == 'surveys' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(surveyChart.colorDomain());
	}else if(mainGraphFilter == 'surveys' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,surveyChart, true);
			});
	}else if(mainGraphFilter == 'qis' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(qisChart.colorDomain());
	}else if(mainGraphFilter == 'qis' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,qisChart, true);
			});
	}else if(mainGraphFilter == 'compare-star' && (graphType == 'Pie' || graphType == 'Doughnut')){
		mainChart
			.colorDomain(compareStarPie.colorDomain());
	}else if(mainGraphFilter == 'compare-star' && graphType == 'Bar'){
		mainChart
			.colorAccessor(function(d,i){
				return setToPieColors(d,i,compareStarPie);
			});
	}
}

function filterMainGraph(){
	mainChart.filterAll();
	mainChart.dimension().filterAll();
	var groupVal = mainChart.dimension().bottom(Infinity);
	var conditions = arguments;
	mainChart.dimension().filterFunction(function(d, i){
		for(var a = 0; a < conditions.length; a++){
			if(!conditions[a](groupVal[i], d)){
				return false;
			}
		}
		mainChart.filter(d);
		return false;
	});
	if(removedResidents.length != 0){
		removeResidentRefresh = true;
	}
	if(this == 'filterAll'){
		var currentFilters = {};
		for(var i = 0; i < dc.chartRegistry.list().length; i++) {
		    var chartI = dc.chartRegistry.list()[i];
		    if(chartI.anchorName() == 'main-chart'){
		    	continue;
		    }
		    var currfilters = chartI.filters();
		    if(currfilters.length != 0){
		    	currentFilters[chartI.anchorName()] = currfilters;
			}
		}
		generateGraphs(true, false, currentFilters);
	}else{
		createMainChart();
		mainChart.render();
		dc.redrawAll();
	}
}

function resetMainGraph(removeAllActive){
	removeAllActive = (removeAllActive != undefined ? removeAllActive : true);
	var currentFilters = {};
	if(removedResidents.length != 0){
		removeResidentRefresh = true;
	}
	for(var i = 0; i < dc.chartRegistry.list().length; i++) {
	    var chartI = dc.chartRegistry.list()[i];
	    if(chartI.anchorName() == 'main-chart'){
	    	continue;
	    }
	    var currfilters = chartI.filters();
	    if(currfilters.length != 0){
	    	currentFilters[chartI.anchorName()] = currfilters;
		}
	}
	if(removeAllActive){
		$('.filter.active').find('.sub-filters').find('.selected').removeClass('selected');
	}
	customFilterValues.readmissions.selected = false;
	generateGraphs(true, false, currentFilters);
}

//change chart type
$(document).on('click', '#graphTypes a', function(e){
	e.preventDefault();
	if($(this).siblings('ul.childDropDown').length > 0){
		return false;
	}
	$('#graphTypes li.selected').removeClass('selected');
	$(this).parent('li').addClass('selected');
	if($(this).closest('ul').hasClass('childDropDown')){
		$(this).closest('ul').parent('li').addClass('selected');
	}
	graphType = $(this).text();
	if(mainGraphFilter != ''){
		graphTypeChange = true;
		generateGraphs(true);
	}
});